var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "time-box" },
      [
        _c(
          "el-card",
          {
            attrs: {
              bordered: false,
              "dis-hover": "",
              padding: 12,
              shadow: "never",
            },
          },
          [
            _c("button-time-picker", {
              on: { dateRangeChange: _vm.dateRangeChange },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm.orderStatisticsData.length &&
    _vm.checkPermi(["merchant:order:statistics:top"])
      ? _c(
          "div",
          { staticClass: "mt14" },
          [
            _c("statistics-data-card-list", {
              attrs: { statisticsData: _vm.orderStatisticsData },
            }),
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "statistic-image-box" },
      [
        _vm.checkPermi(["merchant:order:statistics:chart"])
          ? _c(
              "el-row",
              { staticClass: "mt14" },
              [
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-card",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.orderLineLoading,
                            expression: "orderLineLoading",
                          },
                        ],
                        attrs: {
                          bordered: false,
                          "dis-hover": "",
                          padding: 12,
                          shadow: "never",
                        },
                      },
                      [
                        _c("echarts-new", {
                          attrs: {
                            "option-data": _vm.orderLineOption,
                            styles: _vm.style,
                            height: "100%",
                            width: "100%",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _c(
          "el-row",
          { staticClass: "mt14", attrs: { gutter: 14 } },
          [
            _vm.checkPermi(["merchant:order:statistics:type"])
              ? _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-card",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.orderTypeLoading,
                            expression: "orderTypeLoading",
                          },
                        ],
                        attrs: {
                          bordered: false,
                          "dis-hover": "",
                          padding: 12,
                          shadow: "never",
                        },
                      },
                      [
                        _c("echarts-new", {
                          attrs: {
                            "option-data": _vm.orderTypeOption,
                            styles: _vm.style,
                            height: "100%",
                            width: "100%",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.checkPermi(["merchant:order:statistics:shipping"])
              ? _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-card",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.orderShippingLoading,
                            expression: "orderShippingLoading",
                          },
                        ],
                        attrs: {
                          bordered: false,
                          "dis-hover": "",
                          padding: 12,
                          shadow: "never",
                        },
                      },
                      [
                        _c("echarts-new", {
                          attrs: {
                            "option-data": _vm.orderShippingOption,
                            styles: _vm.style,
                            height: "100%",
                            width: "100%",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }